import React, { useEffect, useRef, useState, useContext } from "react";
import { LMDrawingContext } from '../contexts/AppContext';
import { getAllMeasurementsForLMInfo, getImpactTargetHalfMm } from "../utils/Utilities";

function ImpactLocation({ selectedSetup, selectedShot, sessionDescription }) {
    const canvasRef = useRef(null);
    const { lmDrawing } = useContext(LMDrawingContext);
    const imageCache = {};

    function getCachedImage(src) {
        // if we've already created an Image for this src, reuse it
        if (imageCache[src]) {
            return imageCache[src];
        }

        // otherwise create it once, store it, and return it
        const img = new Image();
        img.src = src;
        imageCache[src] = img;
        return img;
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        let outerImpactX = 0;
        let outerImpactY = 0;
        let innerImpactX = 0;
        let innerImpactY = 0;
        let isAdjusted = false;
        let clubImg = "/heads/driver.png";
        let hasImpactLoc = false;

        if (selectedShot && selectedSetup) {
            hasImpactLoc =
                selectedShot.LMInfos?.some(item => {
                    const measurements = getAllMeasurementsForLMInfo(item);
                    const rawX = measurements.ImpactHorizLocInch;//When ImpactHorizLocMM?
                    const rawY = measurements.ImpactVertLocInch;
                    const adjX = measurements.AdjImpHorizLocInch;
                    const adjY = measurements.AdjImpVertLocInch;
                    const hasRaw = rawX != null && rawY != null;
                    const hasAdjusted = adjX != null && adjY != null;

                    if (item.LMType === lmDrawing && (hasRaw || hasAdjusted)) {
                        outerImpactX = hasAdjusted ? adjX : rawX;
                        outerImpactY = hasAdjusted ? adjY : rawY;
                        innerImpactX = hasRaw ? rawX : outerImpactX;
                        innerImpactY = hasRaw ? rawY : outerImpactY;
                        isAdjusted = hasAdjusted;
                        return true;
                    }
                    else {
                        outerImpactX = 0;
                        outerImpactY = 0;
                        innerImpactX = 0;
                        innerImpactY = 0;
                        return false;
                    }
                }
                );
        } else {
            hasImpactLoc = false;
        }

        let offsetX = 4;
        let offsetY = -1.5;
        let category = selectedSetup ? selectedSetup.PCCategoryId : "1";

        // category = "13";

        switch (category) {
            default:
            case "1":
                clubImg = "/heads/driver.png";
                offsetX = 4;
                offsetY = -1.5;
                break;
            case "2":
                clubImg = "/heads/iron.png";
                offsetX = 12;
                offsetY = -32;
                break;
            case "4":
                clubImg = "/heads/wedge.png";
                offsetX = 50;
                offsetY = -30;
                break;
            case "13":
                clubImg = "/heads/hybrid.png";
                offsetX = 16;
                offsetY = -44;
                break;
        }

        const ctx = canvas.getContext("2d");
        const centerX = canvas.width / 2;
        const centerY = canvas.height / 2;


        const conversionX = 100.0 / 30.0;
        const conversionY = 90.0 / 30.0;

        let outerXPt = outerImpactX;
        let outerYPt = outerImpactY;
        let innerXPt = innerImpactX;
        let innerYPt = innerImpactY;

        // let x_pt = -0.590551;
        // let y_pt = 0;//0.984252;

        let debug_x = 0;
        let debug_y = 0;

        outerXPt = (outerXPt * 25.4) * conversionX + offsetX;
        outerYPt = (outerYPt * 25.4) * conversionY + offsetY;
        innerXPt = (innerXPt * 25.4) * conversionX + offsetX;
        innerYPt = (innerYPt * 25.4) * conversionY + offsetY;

        outerYPt *= -1;
        outerXPt *= -1;
        innerYPt *= -1;
        innerXPt *= -1;

        debug_x = (debug_x * 25.4) * conversionX + offsetX;
        debug_y = (debug_y * 25.4) * conversionY + offsetY;

        debug_x *= -1;
        debug_y *= -1;

        const img = getCachedImage(clubImg);
        img.onload = () => {
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const imgWidth = img.width;
            const imgHeight = img.height;

            // Scale to fit (aspect fit)
            const scale = Math.min(
                canvasWidth / imgWidth,
                canvasHeight / imgHeight
            );

            const drawWidth = imgWidth * scale;
            const drawHeight = imgHeight * scale;

            // Center the image on the canvas
            const dx = (canvasWidth - drawWidth) / 2;
            const dy = (canvasHeight - drawHeight) / 2;

            // Optional: clear the canvas first
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);

            ctx.drawImage(img, dx, dy, drawWidth, drawHeight);

            drawPlusSignPath(ctx, debug_x + centerX, debug_y + centerY);

            const targetInfo = selectedSetup?.TestParameters?.RobotFaceMap;
            const targetXInch = Number(targetInfo?.y);
            const targetYInch = Number(targetInfo?.z);
            const hasTarget = Number.isFinite(targetXInch) && Number.isFinite(targetYInch);

            

            if (hasImpactLoc) {
                const outerCenterX = outerXPt + centerX;
                const outerCenterY = outerYPt + centerY;
                const innerCenterX = innerXPt + centerX;
                const innerCenterY = innerYPt + centerY;
                const outerRadius = 20;
                const innerRadius = outerRadius / 2;

                ctx.beginPath();
                ctx.arc(outerCenterX, outerCenterY, outerRadius, 0, 2 * Math.PI);
                ctx.fillStyle = "#ff00dd6e";
                ctx.fill();

                //ctx.setLineDash([5, 4]);
                ctx.lineWidth = 2;
                ctx.strokeStyle = "#00FFFF";
                ctx.strokeStyle = "#ff00dd"
                ctx.stroke();
                ctx.setLineDash([]);

                ctx.beginPath();
                ctx.arc(innerCenterX, innerCenterY, innerRadius, 0, 2 * Math.PI);
                ctx.lineWidth = 2;
                ctx.strokeStyle = "#00FFFF";
                ctx.stroke();
                ctx.fillStyle = "#ff00dd36";
                ctx.fillStyle = "#00ffff2c"
                ctx.fill();

                const rawLabel = `Raw: ${(innerImpactX * 25.4).toFixed(0)}mm, ${(innerImpactY * 25.4).toFixed(0)}mm`;
                const adjLabel = `Adj: ${(outerImpactX * 25.4).toFixed(0)}mm, ${(outerImpactY * 25.4).toFixed(0)}mm`;
                const headerY = 20;
                const gapWidth = 18;

                ctx.font = "bold 16px Arial";
                const rawWidth = ctx.measureText(rawLabel).width;
                const adjWidth = ctx.measureText(adjLabel).width;
                const totalWidth = rawWidth + gapWidth + adjWidth;
                const startX = centerX - totalWidth / 2;

                ctx.textAlign = "left";
                ctx.lineWidth = 3;
                ctx.strokeStyle = "#000";

                ctx.fillStyle = "#00FFFF";
                ctx.strokeText(rawLabel, startX, headerY);
                ctx.fillText(rawLabel, startX, headerY);

                ctx.fillStyle = "#ff00ff";
                ctx.strokeText(adjLabel, startX + rawWidth + gapWidth, headerY);
                ctx.fillText(adjLabel, startX + rawWidth + gapWidth, headerY);

            } else {
                ctx.fillStyle = "#00000049"
                ctx.fillRect(0, 0, canvasWidth, canvasHeight);

                ctx.fillStyle = "#ffffffff";
                ctx.font = "bold 24px Arial";
                ctx.textAlign = "center";
                ctx.fillText("No impact locations", centerX, centerY);
            }
            if (hasTarget) {
                let t_x = (targetXInch * 25.4) * conversionX + offsetX;
                let t_y = (targetYInch * 25.4) * conversionY + offsetY;
                t_x *= -1;
                t_y *= -1;

                const halfBoxMm = getImpactTargetHalfMm(sessionDescription);
                const halfBoxX = halfBoxMm * conversionX;
                const halfBoxY = halfBoxMm * conversionY;

                //ctx.setLineDash([4, 4]);
                ctx.setLineDash([]);
                ctx.strokeStyle = "#1eff00";
                ctx.strokeRect(
                    centerX + t_x - halfBoxX,
                    centerY + t_y - halfBoxY,
                    halfBoxX * 2,
                    halfBoxY * 2
                );
                ctx.setLineDash([]);

                ctx.textAlign = "center";
                ctx.fillStyle = "#1eff00";
                ctx.font = "bold 16px Arial";
                ctx.strokeStyle = "#000";
                ctx.lineWidth = 3;
                ctx.strokeText("Target", centerX, canvasHeight - 10);
                ctx.fillText("Target", centerX, canvasHeight - 10);
            }
        }


        img.src = clubImg;

    }, [selectedSetup, selectedShot, sessionDescription, lmDrawing]);

    function drawPlusSignPath(ctx, pos_x, pos_y) {
        const size = 18; // Half length of the total cross
        const width = 1; // Half width of the lines

        ctx.beginPath();
        // Move to the center
        ctx.moveTo(pos_x, pos_y);

        // Define the path for the horizontal and vertical bars
        ctx.moveTo(pos_x - size, pos_y + width);
        ctx.lineTo(pos_x + size, pos_y + width);
        ctx.lineTo(pos_x + size, pos_y - width);
        ctx.lineTo(pos_x - size, pos_y - width);
        ctx.closePath();

        ctx.moveTo(pos_x + width, pos_y - size);
        ctx.lineTo(pos_x + width, pos_y + size);
        ctx.lineTo(pos_x - width, pos_y + size);
        ctx.lineTo(pos_x - width, pos_y - size);
        ctx.closePath();

        ctx.fillStyle = "blue";
        ctx.fill();
    }

    return (
        <>
            <canvas
                ref={canvasRef}
                width={400}
                height={300}
            />
        </>
    );
}
export default ImpactLocation;
